import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { PainSection } from './components/sections/PainSection';
import { ImagineSection } from './components/sections/ImagineSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { ProductShowcaseSection } from './components/sections/ProductShowcaseSection';
import { NextTrainingSection } from './components/sections/NextTrainingSection';
import { OfferSection } from './components/sections/OfferSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-0" data-mp="23v2td3l0915e">
      <noscript data-id="element-1" data-mp="3iiwasc8k4vxf">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ijfthv617oci" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="3recbnd7qcbci" />
      <main data-id="element-4" data-mp="5osn3wyp084">
        <ProblemSection data-id="element-5" data-mp="6hovayao7c0" />
        <PainSection data-id="element-6" data-mp="4n53zyrel9i" />
        <ImagineSection data-id="element-7" data-mp="56l3b4umzkw" />
        <VolumesSection data-id="element-8" data-mp="2zl3azit8d249" />
        <BonusesSection data-id="element-9" data-mp="2zlv6ktmtuzuj" />
        <ProductShowcaseSection data-id="element-10" data-mp="2zmemy5wtxg6g" />
        <NextTrainingSection data-id="element-11" data-mp="2zng0qi58cgrv" />
        <OfferSection data-id="element-12" data-mp="33m5cy7ej7s9x" />
        <FinalCtaSection data-id="element-13" data-mp="33nq921ghvj9w" />
      </main>
      <PurchasePopup data-id="element-14" data-mp="33orkw85c49so" />
    </div>;
}